import { render, staticRenderFns } from "./CustomerChatButton.vue?vue&type=template&id=da40ab90&"
import script from "./CustomerChatButton.vue?vue&type=script&lang=js&"
export * from "./CustomerChatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports